<div class="tag-label">
  <ng-content></ng-content>
</div>